<template>
<!-- SALDO FINAL -->
    <tbody v-if="contas && contas.length">
        <tr>
            <td>
                <a href="#" @click.prevent="expanded = !expanded" class="card-link text-dark">
                    <i class="far fa-plus-square" aria-hidden="true" v-if="!expanded"></i>
                    <i class="far fa-minus-square" aria-hidden="true" v-else></i>
                </a>
                {{ titulo }}
            </td>
            <td class="text-right" v-if="tipo_saldo != 'C'">
                {{ getValor(contas, 'saldo_r', null, true) }}
            </td>
            <td class="text-right" v-if="tipo_saldo != 'F'">
                {{ getValor(contas, 'saldo_c', null, true) }}
            </td>
        </tr>
        <template v-if="expanded">
            <tr class="table-secondary" v-for="(conta, icx) in contas" :key="icx">
                <td>{{ conta.search }}</td>
                <td class="text-right" v-if="tipo_saldo != 'C'">{{ $util.formatMoeda(conta.saldo_r) }}</td>
                <td class="text-right" v-if="tipo_saldo != 'F'">{{ $util.formatMoeda(conta.saldo_c) }}</td>
            </tr>
        </template>
    </tbody>
</template>

<script>
import _ from 'lodash';

export default {
    data() { 
        return { 
            expanded: false, 
        };
    },

    props: ['titulo', 'contas', 'tipo_saldo'],

    methods: { 
        getValor (base, campo, filtro = null, formatado = true) { 
            let valor = base.filter (item => { 
                if ( !filtro )
                return true;

                return !_.find(filtro, (element, chave) => {
                    return item[chave] != element;
                });
            })
            .reduce((total, item) => { 
                return total + item[campo];
            }, 0);

            return formatado ? this.$util.formatMoeda(valor) : valor;
        },
    }
}
</script>